import React from 'react';
import { useSelector } from 'react-redux';
import { CancelPanel, InviteGuestPanel, Loading, ModifyGuestPanel } from '../../components';
import { useTripStoreUpdater } from '../../hooks';

import { TripState } from '../../types/trip.store.type';
import { TranslationUtils } from '../../utils';

export const ModifyTrip: React.FC = () => {
    useTripStoreUpdater(false, true);
    const trip = useSelector((store: { trip: TripState }) => store.trip);
    if (trip.isLoading) {
        return <Loading />;
    }

    const { guests, stay, reservation, home_info, unit } = trip;
    if (!guests || !stay || !reservation || !home_info || !unit) {
        return null;
    }

    const { max_counts, secondary } = guests;
    const remainingGuests = max_counts.total_people - (secondary.length + 1);
    const isInvitesFull = remainingGuests === 0;
    const localPhoneNumber = unit.local_phone_number;
    return (
        <div>
            <h1 tabIndex={0} className="heading-large page-title">
                {TranslationUtils.get('manage_guests_title')}
            </h1>
            <ModifyGuestPanel
                home_info={home_info}
                guests={guests}
                stay={stay}
                reservation={reservation}
                localPhoneNumber={localPhoneNumber}
            />
            <InviteGuestPanel isInvitesFull={isInvitesFull} reservation={reservation} />
            <CancelPanel />
        </div>
    );
};
